"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGeoPointInGeoPolygon = void 0;
/**
 * https://www.algorithms-and-technologies.com/point_in_polygon/javascript
 * Performs the even-odd-rule Algorithm (a raycasting algorithm) to find out whether a point is in a given polygon.
 * This runs in O(n) where n is the number of edges of the polygon.
 *
 * @param {Object} point latitude and longitude of the point
 * @param {Array} polygon an array representation of the polygon where polygon[i][0] is the longitude Value of the i-th point and polygon[i][1] is the latitude Value.
 * @return {boolean} whether the point is in the polygon (not on the edge, just turn < into <= and > into >= for that)
 */
const isGeoPointInGeoPolygon = ({ longitude, latitude }, polygon) => {
    // A point is in a polygon if a line from the point to infinity crosses the polygon an odd number of times
    let odd = false;
    // For each edge (In this case for each point of the polygon and the previous one)
    for (let i = 0, j = polygon.length - 1; i < polygon.length; i++) {
        // If a line from the point into infinity crosses this edge
        if (polygon[i][1] > latitude !== polygon[j][1] > latitude && // One point needs to be above, one below our latitude
            // ...and the edge doesn't cross latitude corrdinate before our longitude coordinate (but between our longitude coordinate and infinity)
            longitude <
                ((polygon[j][0] - polygon[i][0]) * (latitude - polygon[i][1])) / (polygon[j][1] - polygon[i][1]) + polygon[i][0]) {
            // Invert odd
            odd = !odd;
        }
        j = i;
    }
    // If the number of crossings was odd, the point is in the polygon
    return odd;
};
exports.isGeoPointInGeoPolygon = isGeoPointInGeoPolygon;
//# sourceMappingURL=isGeoPointInGeoPolygon.js.map